<template>
  <div v-if="completionMonth && teams">
    <h1>Completion month</h1>
    <v-select
      v-model="teamId"
      :items="teams"
      item-value="id"
      label="Team"
      @change="navigate"
      outline
    >
      <template slot="selection" slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template
      >
      <template slot="item" slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template
      >
      <template slot="append-outer" v-if="teamId">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                teamId = null;
                navigate();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Show all teams</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-layout row>
      <v-flex xs12 md9>
        <a
          @click="
            monthOffset = monthOffset - 1;
            navigate();
          "
        >
          <v-icon>chevron_left</v-icon>
        </a>
        <span>{{ completionMonth.theMonth }}</span>
        <a
          @click="
            monthOffset = monthOffset + 1;
            navigate();
          "
        >
          <v-icon>chevron_right</v-icon>
        </a>
      </v-flex>
      <v-flex xs12 md3>
        <v-btn @click="download()">
          <v-icon>picture_as_pdf</v-icon>&#160;View pdf
        </v-btn>
      </v-flex>
    </v-layout>
    <table border="1" class="completionMonth">
      <tr>
        <th style="width: 14%">Monday</th>
        <th style="width: 14%">Tuesday</th>
        <th style="width: 14%">Wednesday</th>
        <th style="width: 14%">Thursday</th>
        <th style="width: 14%">Friday</th>
        <th style="width: 14%">Saturday</th>
        <th style="width: 14%">Sunday</th>
      </tr>
      <tr
        style="height: 60px"
        v-for="(completionWeek, cwindex) in completionMonth.completionWeek"
        :key="cwindex"
      >
        <td
          :class="`cal${completionDay.styleClass}`"
          v-for="(completionDay, cdindex) in completionWeek.completionDay"
          :key="cdindex"
        >
          <div class="completionDayCount" v-if="completionDay.count > 0">
            {{ completionDay.count }}
          </div>
          <div>{{ completionDay.date | formatDay }}</div>
          <div
            v-for="fileMini in completionDay.fileMini"
            :key="fileMini.fileId"
          >
            <File :file="fileMini" />
            {{ fileMini.categoryCode }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import TEAMS from "@/graphql/directory/Teams";
import File from "@/components/link/File";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "CompletionMonth",
  components: { File },
  metaInfo() {
    return {
      title: "Completion month",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    teams: {
      query: TEAMS,
      variables: { archived: false },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      completionMonth: null,
      monthOffset: null,
      teamId: null
    };
  },
  methods: {
    fetchCompletionMonth() {
      nbmlaw
        .get(`/cors/admin/file/completionMonth`, {
          params: {
            monthOffset: this.$route.query.monthOffset,
            teamId: this.teamId
          }
        })
        .then((response) => {
          // console.log(response.data);
          this.completionMonth = response.data;
        })
        .catch(() => {});
    },
    navigate() {
      this.$router.push({
        name: "completionMonth",
        query: { monthOffset: this.monthOffset, teamId: this.teamId }
      });
    },
    download() {
      var url = new URL(
        `${process.env.VUE_APP_CT_URL}/cors/admin/file/completionMonth/pdf`
      );
      if (this.monthOffset) {
        url.searchParams.append("monthOffset", this.monthOffset);
      }
      if (this.teamId) {
        url.searchParams.set("teamId", this.teamId);
      }
      window.open(url.href, "_blank");
    },
    fetchAll() {
      this.monthOffset = this.$route.query.monthOffset
        ? this.$route.query.monthOffset
        : 0;
      this.teamId = this.$route.query.teamId;
      this.fetchCompletionMonth();
    }
  },
  watch: {
    "$route.query.monthOffset": {
      immediate: true,
      handler() {
        this.fetchAll();
      }
    },
    "$route.query.teamId": {
      immediate: true,
      handler() {
        this.fetchAll();
      }
    }
  }
};
</script>

<style>
.completionMonth {
  width: 100%;
  font-size: 0.8em;
}

.completionMonth td {
  vertical-align: top;
}

.calweekend {
  background: #dddddd;
}

.calnextmonth {
  background: #aaaaaa;
}

.calselected {
  background: #99dd99;
}

.caltoday {
  background: #ccccff;
}

.completionDayCount {
  float: right;
  color: gray;
  font-size: 0.8em;
}
</style>
